import { useTranslation } from 'react-i18next'
import { emailSelectors, useEmail } from '../store'
import { FormSelectDataType } from '@systemeio/ui'

enum ReplacementsEnum {
  SubstitutionTagAffiliateId = 'affiliate_id',
  SubstitutionTagAffiliateDashboardUrl = 'affiliate_dashboard',
}

const replacementsTitles = {
  [ReplacementsEnum.SubstitutionTagAffiliateId]: 'text_replacements.affiliate_id',
  [ReplacementsEnum.SubstitutionTagAffiliateDashboardUrl]: 'text_replacements.affiliate_dashboard',
}

export const useSubstitutions = () => {
  const { t } = useTranslation()
  const contactFields = useEmail(emailSelectors.getContactFields)

  const mainSubstitutions = contactFields.map(contactField => ({
    id: `{${contactField.slug}}`,
    caption: contactField.name,
  }))

  const additionalSubstitutions: FormSelectDataType<string>[] = [
    {
      id: `${ReplacementsEnum.SubstitutionTagAffiliateId}`,
      caption: t(replacementsTitles[ReplacementsEnum.SubstitutionTagAffiliateId]),
    },
    {
      id: `${ReplacementsEnum.SubstitutionTagAffiliateDashboardUrl}`,
      caption: t(replacementsTitles[ReplacementsEnum.SubstitutionTagAffiliateDashboardUrl]),
    },
  ]

  const substitutions: FormSelectDataType<string>[] = [
    ...mainSubstitutions,
    ...additionalSubstitutions,
  ]

  return {
    substitutions,
  }
}
